import React, { useState } from 'react';
import Menu from '../../../components/menu/menu';
import Av from 'react-avatar';
import '../style';
import { formatTimestamp, getMenuItems } from '../util';
const EventListItem = ({event, status, onEdit,onView, onDelete, allowViewOnClick }) =>{
  const{
    name,
    image,
    geo_location,
    start_date,
    end_date,
    isUnderReview,
    type,
  } = event;

  const handleMenuClick = (item) => {
    if (item.id === 'Edit') {
      onEdit(event.id);
    } else if (item.id === 'View event') {
      onView(event.id);
    } else if(item.id === 'Delete'){
      onDelete(event.id);
    }
  };
  const { monthAbbreviated, startDay, startTime, endTime } = formatTimestamp(start_date, end_date);

  return(
    window.innerWidth <= 768 ? (
<div
  className={`flex flex-col border-2 border-grey-10 w-full rounded-xl overflow-hidden bg-white relative ${
    allowViewOnClick
      ? 'cursor-pointer hover:shadow-md transition-shadow duration-200'
      : ''
  }`}
  {...(allowViewOnClick && { onClick: () => onView(event.id) })}
>
  {/* Image section */}
  <div className="relative w-full h-[120px]">
    {/* Date badge */}
    <div className="absolute top-2 left-2 bg-[#FFE8EF] text-center rounded-md px-2 py-1 leading-tight shadow-sm">
      <div className="text-[#FF3C6B] font-bold text-xs">{monthAbbreviated}</div>
      <div className="text-black font-bold text-lg -mt-1">{startDay}</div>
    </div>

    {/* Menu button (three dots) */}

    {!!getMenuItems(status)?.length &&
        (
        <div className = "event-menu absolute top-2 right-2 flex gap-5 items-center bg-white px-2 py-1 rounded-full shadow-sm">
        <Menu
          menuItems={getMenuItems(status)}
          onClick={handleMenuClick}
          />
          </div>)}

    {/* Event image */}
    {image ? (
      <img
        src={image}
        alt={`${name} logo`}
        className="w-full h-full object-cover"
      />
    ) : (
      <Av
        name={name}
        size={120}
        color="#FFF2F2"
        fgColor="#FF3C6B"
        maxInitials={1}
        round={false}
        className="!w-full h-full rounded-none"
      />
    )}
  </div>

  {/* Content section */}
  <div className="p-4 flex flex-col gap-1">
    <div className="font-bold text-[15px] leading-tight">{name}</div>
    <div className="text-[#878787] text-sm whitespace-nowrap">
      {type === 'online' ? 'Online Event' : geo_location} · {startTime} to {endTime}
    </div>
  </div>
</div>
    ) : (
      <>
 <div
      className={`flex pr-8 pl-5 py-5 justify-between border-2 border-grey-10 w-full items-center rounded-xl ${allowViewOnClick ? 'cursor-pointer' : ''}`}
      {...allowViewOnClick && ({
        onClick: () => onView(event.id)
      })}
    >
      <div className='flex gap-6 items-center'>
        <div className="rounded-md bg-light shadow-sm flex flex-col px-4 py-2 items-center justify-center gap-[2px] h-[72px] w-[58px] text-center text-primary border-[0.5px] border-transparent">
          <div className="relative tracking-[-1px] leading-[102.7%] font-semibold inline-block w-8">
            {monthAbbreviated}
          </div>
          <div className="relative text-xl tracking-[-1px] leading-[102.7%] font-semibold">
            {startDay}
          </div>
        </div>
        <div className='flex  gap-5 '>
          <div className='w-[126px] h-[72px] max-h-20 object-cover'>
            {image ? (<img src={image} 
              alt={` ${name} logo`}
              className='w-[126px] h-[72px] max-h-20 object-cover rounded-lg'
            />) : (
              <Av
              name={name}
              size={72}
              color="#FFF2F2"
              fgColor="#FF3C6B"
              maxInitials={1}
              round={false}
              className='!w-[126px] h-[72px] rounded-lg'
            />
            )}
          </div>        
          <div className='heading-18 flex flex-col gap-3'>{name}
            <div className='flex gap-2 items-center text-16'>{type === 'online' ? 'Online Event' : geo_location} <span className='mb-2'>.</span> {startTime} to {endTime}</div>
          </div>
        </div>
      </div>
      <div className="event-menu flex gap-5 items-center" >
        {(status === 'upcoming' && isUnderReview) && (<div className='bg-grey-10 px-4 py-2 rounded-lg items-center label-14 '> Under review</div>)}
        {!!getMenuItems(status)?.length &&
        (<Menu
          menuItems={getMenuItems(status)}
          onClick={handleMenuClick}
        />)
        }
      </div>
    </div>
      </>
    )
  );
};

export default EventListItem;
